import { motion } from 'framer-motion';
import React, { useEffect, useState } from "react";
import useAvailableHeight from '../../Custom/UseAvailableHeight';
import UserDetailContext, { useUserDetailContext } from '../../UserDetailContext';
import CardWaveStd from '../../Utilities/CardWaveStd';
import CardWaveSmile from '../../Utilities/CardWaveSmile2';
import DefaultProfileBg from "../../../Assets/img/card/profilebg.png";
import DefaultLogo from "../../../Assets/img/default-logo.png";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getAllCardDetailsReducer, getAllCardInfoReducer } from '../../../Redux/Reducers/CardReducer';
// import { Box } from '@material-ui/core';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

// import Visa from '../../.././Assets/img/logo (1).png';
import { Link, useNavigate } from 'react-router-dom'
import chip from '../../.././Assets/img/icons/chip.png';
import { QrCodeVisitingCard } from '../Cards/QrCodeCard';
import { useCreateCardDetailContext } from '../../CreatecardDetailContext';
import { useCardDetailContext } from '../../CardDetailContext';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ReactComponent as ProfessionalIcon } from '../../../Assets/img/icons/Professional-icon.svg';
import { Box, Button, IconButton, Modal } from "@mui/material";
// import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { ReactComponent as StudentIcon } from '../../../Assets/img/icons/Student.svg';
import Secure from '../../../Assets/Secure.svg';
import cardbg from '../../../Assets/img/cardBg.webp';
import Neoin_logo from '../../../Assets/img/Neoin-logo.png';
import Visa from '../../../Assets/img/VisaIcon.svg';


const HomepageLeftFeedd = ({ activeMenu }) => {
    // const dispatch = useDispatch();

    const [showActiveModal, setShowActiveModal] = useState(false);
    const navigate = useNavigate();
    const [NewCardType, setNewCardType] = useState('');
    const [chooseCategory, setchooseCategory] = useState(false);
    const AllCards = useSelector((state) => state?.CardArray?.AllCardDetailsInfo);

    const cardDetailsAll = useSelector((state) => state?.CardArray?.AllCardsInfo?.Details);

    const cardStylesAll = useSelector((state) => state?.CardArray?.AllCardsInfo?.CardDesigns
    );

    const AllcardQrstyleInfo = useSelector((state) => state?.CardArray?.AllCardsInfo?.QrStyles

    );
    // console.log("All card Details Info ", cardDetailsAll);
    // console.log("All card Style Info ", cardStylesAll);
    // console.log("All card QRstyle Info ", AllcardQrstyleInfo);

    const { cards } = useCardDetailContext();
    const { setCardDetails, setCardStyles, setCardQrStyles, setContactStyles, setSocialLinks, setAttachDocs,
        setIsPersonalDetailsSaved, updateCardDetails, updateSocialLinks2, updateCardStyles, updateCardQrStyles, updateContactStyles, updateAttachDocsVal } = useCreateCardDetailContext();

    const handleCardTypeClick = (category) => {
        console.log("Category :", category);
        setNewCardType(category);
        updateCardDetails({ "CardType": category });
        updateCardStyles({ "CardType": category });
        if (category === "Customize_Personal") {
            updateCardStyles({ "layoutStyle": '2' }); //For Personal Card - Default Layout is 2
        }
        updateCardQrStyles({ "CardType": category });
        updateSocialLinks2({ "card_type": category });
        updateContactStyles({ "card_type": category, mobile_number: userDetails?.phone, email: userDetails?.email });
        updateAttachDocsVal({ fieldName: "card_name", value: category }); // It is Needed If CardType is GenZ itself
        setchooseCategory(false);
        // setChooseCustomizeCategory(false);
        // setIsPersonalDetailsSaved(false);
        navigate('/create-card', { state: { category: category } });
    };

    useEffect(() => {
        const allowedCards = ['Professional', 'Student', 'Customize_Student', 'Customize_Professional'];
        const hasValidCard = AllCards.some(card => allowedCards.includes(card?.card_type)); // Check `card_type`, not the whole object
        console.log("hasValidCard", hasValidCard);
        if (activeMenu === "professional_profile") {
            setShowActiveModal(!hasValidCard);
        }
        // Show modal if NO valid card exists
    }, [activeMenu]);

    const handleOpenActivebutton = () => {
        setchooseCategory(true);
        setShowActiveModal(false);
    };

    const [availableHeight3, Column3Ref] = useAvailableHeight(166);
    const [qrDialogueOpen, setQrDialogueOpen] = useState(false);

    const handleCloseDialogue = () => {
        setQrDialogueOpen(false);
    };
    const rightToLeftVariants = {
        hidden: { opacity: 0, x: 100 },
        visible: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: -100 },
    };


    const { userDetails } = useUserDetailContext();
    const [firstName, lastName] = userDetails.name.split(' ');

    const renderCards = (menuType, allowedCardTypes) => {
        if (!Array.isArray(AllCards) || AllCards?.length === 0) {
            return <p>No cards available.</p>;
        }

        const filteredCards = AllCards.filter(card => allowedCardTypes.includes(card?.card_type));

        if (filteredCards.length === 0) {

            // const allowedCards = ['Professional', 'Student', 'Customize_Student', 'Customize_Professional'];
            // const hasValidCard = AllCards.some(card => allowedCards.includes(card.card_type)); // Check `card_type`, not the whole object
            // console.log("hasValidCard", hasValidCard);

            // setShowActiveModal(!hasValidCard);
            return <div className="m-4 d-flex justify-content-center align-item-center" style={{ border: "1px solid rgba(113, 118, 123, 0.2)", borderRadius: "4px" }}>
                <p className="m-0 py-2" style={{ color: "#00000099", textAlign: "center" }}>No cards available.</p>
            </div>;
        }

        return filteredCards.map(card => {
            const cardDetails = cardDetailsAll?.find(state => state?.CardName === card?.card_name);
            const cardStyles = cardStylesAll?.find(state => state?.CardName === card?.card_name);

            if (!cardDetails) return null;

            const styles = cardStyles || {};
            const companyLogoData = cardDetails?.logo || DefaultLogo;
            const profilePic = cardDetails?.profile_pic || DefaultProfileBg;
            const cardBackgroundColor = styles?.bgColor || "#ffffff";
            const colorLayout = styles?.colorLayout || "#0044c6";
            const colorPrimary = styles?.colorPrimary;
            const colorSecondary = styles?.colorSecondary;
            const fontFamily = styles?.font;
            const cardType = card?.card_type;

            return (
                <div key={card.card_name} className={`digi-card card-row`} style={{ backgroundColor: cardBackgroundColor, fontFamily, width: "400px" }}>
                    <a href={`/card/${card.card_name}`}>
                        <div className="digi-card-upper" style={{ backgroundImage: `url(${profilePic})`, position: "relative" }}>
                            <div className="digi-card-label-container" style={{ backgroundColor: colorLayout }}>
                                <span className="digi-card-label">{card.card_name}</span>
                            </div>
                            {cardType === "Personal" || cardType === "Customize_Personal" ? (
                                <CardWaveSmile bgColor={cardBackgroundColor} strokeColor={colorLayout} small />
                            ) : (
                                <CardWaveStd bgColor={cardBackgroundColor} strokeColor={colorLayout} small />
                            )}
                            {!(cardType === "Personal" || cardType === "Customize_Personal") && (
                                <div className="company-logo-container flex-center">
                                    <img src={companyLogoData} alt="Company" className="prof-company-logo" />
                                </div>
                            )}
                        </div>
                        <div className="digi-card-lower ps-2">
                            <h2 className="digi-card-Name d-flex justify-content-start " style={{ color: colorPrimary }}>{firstName}</h2>
                            <span className="digi-card-Name d-flex" style={{ color: colorSecondary }}>
                                {cardType.includes("Professional")
                                    ? cardDetails?.companyName
                                        ? `${cardDetails?.companyName} - ${cardDetails?.designation}`
                                        : cardDetails?.designation
                                    : cardDetails?.title}
                            </span>
                        </div>
                    </a>
                </div>
            );
        });
    };
    return (
        <>
            <motion.div className="homepage-card-box-1 " ref={Column3Ref} style={{ maxHeight: "612px", overflowY: "auto", scrollbarWidth: "none", width: '100%' }} initial="hidden"
                animate="visible"
                exit="exit"
                variants={rightToLeftVariants}
                transition={{ duration: 0.5 }}>
                <div className="card-title other-cards-title pt-3 px-3 ">My Cards</div>
                <div className="" >
                    <div className="scrollable-container-cont">



                        {/* Array.isArray(AllCards) && AllCards.length > 0 ? (
                        AllCards
                                    ?.filter(card => card.card_type === "Personal" || card.card_type === "Customize_Personal")
                                    ?.map(card => {
                                        // Find the matching card details and styles for each card
                                        const CardDetailsFilterByName = cardDetailsAll?.find((state) => state?.CardName === card.card_name);
                                        const CardDeailsForStyles = cardStylesAll?.find((state) => state?.CardName === card.card_name);

                        // If no card details are found, return null
                        if (!CardDetailsFilterByName) return null;

                        // Now, CardDetailsFilterByName and CardDeailsForStyles will each hold only one object or undefined if no match is found
                       

                        // Set default values if data or styles are missing
                        const styles = CardDeailsForStyles || { }; // Use an empty object if no styles are found
                        const companyLogoData = CardDetailsFilterByName?.logo || DefaultLogo;
                        const profilePic = CardDetailsFilterByName?.profile_pic || DefaultProfileBg;
                        const cardBackgroundColor = styles?.bgColor || "#ffffff";
                        const colorLayout = styles?.colorLayout || '#0044c6';
                        const colorPrimary = styles?.colorPrimary;
                        const colorSecondary = styles?.colorSecondary;
                        const fontFamily = styles?.font;
                        const cardType = card.card_type;

                        return (
                        <div key={card.card_name} className={`digi-card card-row card-professional`} style={{ backgroundColor: cardBackgroundColor, marginLeft: "unset", fontFamily: fontFamily, width: "400px" }}>
                            <a href={`/card/${card.card_name}`}>
                                <div className='digi-card-upper' style={{
                                    backgroundImage: `url(${profilePic})`,
                                    position: "relative"
                                }}>
                                    <div className='digi-card-label-container' style={{ backgroundColor: colorLayout }}>
                                        <span className='digi-card-label'>{card.card_name}</span>
                                    </div>

                                    {(cardType === 'Personal' || cardType === 'Customize_Personal') ? (
                                        <CardWaveSmile bgColor={cardBackgroundColor} strokeColor={colorLayout} small />
                                    ) : (
                                        <CardWaveStd bgColor={cardBackgroundColor} strokeColor={colorLayout} small />
                                    )}

                                    {(cardType === 'Personal' || cardType === 'Customize_Personal') ? null : (
                                        <div className='company-logo-container flex-center'>
                                            <img src={companyLogoData} alt="Company" className='prof-company-logo' />
                                        </div>
                                    )}
                                </div>
                                <div className='digi-card-lower'>
                                    <h2 className='digi-card-Name' style={{ color: colorPrimary }}>{firstName}</h2>
                                    <span className='Profession' style={{ color: colorSecondary }}>
                                        {(cardType === "Professional" || cardType === "Customize_Professional")
                                            ? (CardDetailsFilterByName?.companyName ? `${CardDetailsFilterByName?.companyName} - ${CardDetailsFilterByName?.designation}` : CardDetailsFilterByName?.designation)
                                            : CardDetailsFilterByName?.title}
                                    </span>
                                </div>
                            </a>
                        </div>
                        */}


                        <>
                            {activeMenu === "personal_profile" && renderCards("personal_profile", ["Personal", "Customize_Personal"])}
                            {activeMenu === "professional_profile" && renderCards("professional_profile", ["Professional", "Customize_Professional", "Student", "Customize_Student"])}
                            {activeMenu === "financel" && (
                                <div className="m-4 d-flex justify-content-center align-item-center" >
                                    {/* <p className="m-0 py-2" style={{ color: "#00000099", textAlign: "center" }}></p> */}
                                    <div style={{
                                        position: 'relative',
                                        width: '250px',
                                        height: '150px',
                                        borderRadius: '5px',
                                        overflow: 'hidden',
                                        backgroundColor: 'rgb(54, 69, 79)'
                                    }}>
                                        <img
                                            src={cardbg}
                                            alt="cardbg"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover', backgroundColor: "rgb(54, 69, 79)" }}
                                        />

                                        <p className="ps-2 pe-2" style={{
                                            position: 'absolute',
                                            top: '15px',
                                            // left: '10px',
                                            color: '#fff',
                                            backgroundColor: "#0044c6",
                                            borderTopRightRadius: "18px",
                                            borderBottomRightRadius: "18px",
                                            // fontWeight: 'bold'
                                            fontSize: "12px"
                                        }}>Financial</p>


                                        <img
                                            src={Neoin_logo}
                                            alt="neoinlogo"
                                            style={{
                                                position: 'absolute',
                                                top: '15px',
                                                right: '10px',
                                                width: '40px' // adjust as needed
                                            }} />


                                        <p style={{
                                            position: 'absolute',
                                            top: '60px',
                                            left: '10px',
                                            color: '#fff',
                                            fontWeight: 'bold'
                                        }}>
                                            7753 3888 2528 22291
                                        </p>
                                        <span className='d-flex flex-column' style={{
                                            position: 'absolute',
                                            bottom: '10px',
                                            left: '10px',
                                            color: '#fff',
                                        }}>
                                            <span className='financial-card-text1'>Holder Name</span>
                                            <span className='financial-card-text2' >{firstName} {lastName}</span>
                                        </span>
                                        <span className='d-flex flex-column' style={{
                                            position: 'absolute',
                                            bottom: '10px',
                                            left: '99px',
                                            color: '#fff',
                                        }}>
                                            <span className='financial-card-text1 ps-1'>Expiry  Date</span>
                                            <span className='financial-card-text2'>12/30</span>
                                        </span>

                                        <span className='ms-3 mt-1' style={{
                                            position: 'absolute',
                                            bottom: '10px',
                                            right: '10px',
                                        }}>
                                            <img src={Visa} alt="Visa Icon" width={45} height={25} />
                                        </span>

                                    </div>

                                </div>
                            )}
                        </>
                    </div>
                </div>
            </motion.div>

            <Modal
                open={showActiveModal}
                onClose={() => {
                    setShowActiveModal(false);
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "auto",
                        bgcolor: "white",
                        boxShadow: "0px 4px 4px 0px #00000040",
                        p: 3,
                        borderRadius: 2,
                        minWidth: "35%",
                        maxHeight: "80%",
                        overflowY: "auto",
                    }}
                >
                    <div className="soc-modal-heading position-relative mb-4">

                        <span className="span-center-align file-attach-icon-container">
                            <IconButton
                                color="rgb(0, 0, 0, 0.54)"
                                onClick={() => {
                                    setShowActiveModal(false);
                                }}
                            >
                                <CloseRoundedIcon />
                            </IconButton>
                        </span>
                    </div>

                    <div className='d-flex flex-column align-items-center justify-content-center'>
                        <img src={Secure} width="240" height="200" alt="image" />
                        <p className='fw-normal'>Please activate your professional Card.</p>
                    </div>
                    <div className="mt-3 d-flex justify-content-center">
                        {/* <Button
                      className="secondary-btn me-3"
                      onClick={handleVerifyEduCancel}
                    >
                      Cancel
                    </Button> */}
                        <Button
                            variant="contained"
                            sx={{ backgroundColor: "#0044C6" }}
                            onClick={handleOpenActivebutton}
                        // disabled={
                        //   !isEmailValid ||
                        //   (!currentEducation.institute_email &&
                        //     !currentEducation.adminEmailId)
                        // }
                        >
                            Activate
                        </Button>
                    </div>

                </Box>
            </Modal>

            {chooseCategory &&
                <>
                    <>
                        <div className="lightbox-overlay">
                            <div className="lightbox-content">
                                <>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <div className='d-flex align-items-center'>
                                            {/* <IconButton onClick={() => { setchooseCategory(false) }}>
                                                <ArrowBackIcon />
                                            </IconButton> */}
                                            <h6 className='heading-fav text-left mb-0 ms-1'>
                                                Choose Category</h6>
                                        </div>
                                        {/* <button style={{ cursor: 'pointer' }} className="lightbox-close2" onClick={handleCloseVerifiedDialog}>×</button> */}
                                        <IconButton
                                            // onClick={handleCloseVerifiedDialog}
                                            onClick={() => { setchooseCategory(false) }}
                                            sx={{ margin: 0, padding: 0 }}>
                                            <CloseRoundedIcon />
                                        </IconButton>
                                    </div>

                                    <div className="mt-2 selectedOptions d-flex align-items-center justify-content-around">
                                        {/* <div className={`mx-2 CardCategory flex-center flex-column `}
                              onClick={() => { setChooseCustomizeCategory(true); setchooseCategory(false) }}>
                              <div className="icon-outside-new"><PersonalCardIcon /></div>
                              <div className="myself">Customize</div>
                            </div> */}
                                        {/* {(!cards.includes('Personal')) && (
                                                  <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType == 'Personal' ? 'selected' : ''}`}
                                                      onClick={() => handleCardTypeClick('Personal')}>
                                                      <div className="icon-outside-new"><ProfessionalIcon /></div>
                                                      <div className="myself">Personal</div>
                                                  </div>
                                              )} */}
                                        {(!cards?.includes('Professional')) && (
                                            <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType == 'Professional' ? 'selected' : ''}`}
                                                onClick={() => handleCardTypeClick('Professional')}>
                                                <div className="icon-outside-new"><ProfessionalIcon /></div>
                                                <div className="myself">Professional</div>
                                            </div>
                                        )}
                                        {(!cards?.includes('Student')) && (
                                            <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType === 'Student' ? 'selected' : ''}`}
                                                onClick={() => handleCardTypeClick('Student')}>
                                                <div className="icon-outside-new"><StudentIcon /></div>
                                                <div className="myself">Student</div>
                                            </div>
                                        )}
                                        {/* {(!cards.includes('GenZ')) && (
                                                      <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType === 'GenZ' ? 'selected' : ''}`}
                                                          onClick={() => handleCardTypeClick('GenZ')}>
                                                          <div className="icon-outside-new"><GenzIcon /></div>
                                                          <div className="myself">GenZ</div>
                                                      </div>
                                                  )} */}
                                    </div>
                                </>
                            </div>
                        </div>
                    </>
                </>
            }
        </>
    );
};
export default HomepageLeftFeedd;


